import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {GenericService} from "../../../services/generic.service";
import {SelectOption} from "../../classes/select-option";
import {radio} from "../weave-radio-group/weave-radio-group.component";

@Component({
    selector: 'app-inline-radio-buttons',
    templateUrl: './inline-radio-buttons.component.html',
    styleUrls: ['./inline-radio-buttons.component.scss'],
    standalone: false
})
export class InlineRadioButtonsComponent implements OnInit {

  @Input() label: string;
  @Input() data: any = null;
  @Input() items: radio[] = [];
  @Input() disabledFlag: boolean;
  @Input() defaultPlaceHolder: string;
  @Output() focusOut: EventEmitter<radio> = new EventEmitter<radio>();

  editMode = false;
  selectedChoice: string;
  initialValue: radio = null;

  @HostListener('document:click', ['$event'])
  click(event) {
    if(
       !this.genericService.isDescendant("editMode", event.target) &&
      // !this.genericService.isDescendant("simpleCheckbox", event.target) &&
       !this.genericService.isDescendant("selectPreviewData", event.target) //&&
      // this.editMode
    ) {
      this.editMode = false;
    }
  }

  constructor(private genericService: GenericService) {
  }

  ngOnInit() {
    this.initialValue = this.data;
    this.selectedChoice = this.data.value;
  }

  onFocusOut(choice) {
    this.selectedChoice = choice;
    this.editMode = false;
    this.data = this.items.find(item => {
      return item.value === this.selectedChoice;
    });
    this.focusOut.emit( this.data );
  }

  editOff() {
    this.editMode = false;
  }

  undo() {
    this.editMode = false;
    this.data = this.initialValue;
    this.focusOut.emit( this.data );
  }
}
